import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path fillRule="evenodd" d="M7.47 7.47a.75.75 0 011.06 0l8.13 8.129a.75.75 0 01-1.061 1.06L7.469 8.53a.75.75 0 010-1.06z" clipRule="evenodd" /><path fillRule="evenodd" d="M16.66 7.47a.75.75 0 00-1.061 0l-8.13 8.129a.75.75 0 001.061 1.06l8.13-8.129a.75.75 0 000-1.06" clipRule="evenodd" /></svg>;